import { c as _c } from "react/compiler-runtime";
import { usePageView } from '@/analytics/pageTypes';
import { GcssLayout } from '@/components/layout/GcssLayout';
import { ResultContent } from '@/sections/gcss/ResultContent';
import { getAllPrimaryCategoriesSlugs, getPrimaryCategoryBySlug } from '@/sections/gcss/functions/getCategories';
import type { Category } from '@/sections/gcss/functions/utils';
import { useGcssValuesToSearch } from '@/sections/gcss/hooks/useGcssSearch';
import { getNoResultsData, type NoResults } from '@/sections/gcss/functions/getNoResultsData';
import { type IntlProps, getIntlProps } from '@/utils/intl';
import type { GetStaticProps } from 'next';
import { Section } from '@/sections/layout/Header/useGcssSections';
import { getHeaderSections } from '@/sections/gcss/functions/getHeaderSections';
import { isAllowedRoute } from '@/lang/pagesConfig';
interface Props extends IntlProps {
  category: Category;
  noResultsData: NoResults;
  headerSections: Section[];
}
export default function Page(props) {
  const $ = _c(14);
  const {
    category,
    noResultsData,
    headerSections
  } = props;
  let t0;
  if ($[0] !== category.name || $[1] !== category.slug) {
    t0 = {
      title: category.name,
      url: category.slug,
      level: "0"
    };
    $[0] = category.name;
    $[1] = category.slug;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  usePageView("gcss-category", t0);
  const {
    formValues,
    sync,
    searchForm
  } = useGcssValuesToSearch();
  let t1;
  if ($[3] !== category || $[4] !== formValues || $[5] !== noResultsData || $[6] !== searchForm || $[7] !== sync) {
    t1 = <ResultContent noResultsData={noResultsData} searchForm={searchForm} formValues={formValues} sync={sync} category={category} />;
    $[3] = category;
    $[4] = formValues;
    $[5] = noResultsData;
    $[6] = searchForm;
    $[7] = sync;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== formValues || $[10] !== headerSections || $[11] !== searchForm || $[12] !== t1) {
    t2 = <GcssLayout headerSections={headerSections} searchForm={searchForm} formValues={formValues}>{t1}</GcssLayout>;
    $[9] = formValues;
    $[10] = headerSections;
    $[11] = searchForm;
    $[12] = t1;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  return t2;
}
export const getStaticPaths = async () => {
  const slugs = await getAllPrimaryCategoriesSlugs();
  const paths = slugs?.map(slug => ({
    params: {
      category: slug
    }
  }));
  return {
    paths: paths?.filter(Boolean) || [],
    fallback: false
  };
};
export const getStaticProps = (async ctx => {
  const isAllowed = isAllowedRoute('srovnavac-produktu/[:category]');
  if (!isAllowed) {
    return {
      notFound: true
    };
  }
  const slug = ctx.params?.category as string;
  const category = await getPrimaryCategoryBySlug(slug);
  return {
    props: {
      category,
      noResultsData: await getNoResultsData(),
      headerSections: await getHeaderSections(),
      ...(await getIntlProps(ctx, ['gcss']))
    }
  };
}) satisfies GetStaticProps<Props>;